import React from 'react'
import { Container } from 'react-bootstrap'

import FooterTop from './components/FooterTop'
import FooterBottom from './components/FooterBottom'

import * as s from './Footer.module.scss'

const Footer = () => {
  return (
    <footer className={s.footer}>
      <Container className={s.container}>
        <FooterTop />
        <hr className={s.hr} />
        <FooterBottom />
      </Container>
    </footer>
  )
}

Footer.defaultProps = {
  siteTitle: '',
  variant: '',
  isFooterPrice: false,
  isFooterBnb: false,
  extraLpLinks: [],
}

export default Footer
